import { useStore } from "vuex";

export default {
  name: 'ChatPanelTrigger',
  props: {
    actionId: {
      type: String
    }
  },
  setup(props) {
    const store = useStore();

    function initActionId() {
      store.dispatch("chatPanel/openChatAndHandleActionId", {
        actionId: props.actionId,
        context: 'chat-panel-trigger-button'
      })
    }

    return {
      initActionId
    }
  }
}